import { render, staticRenderFns } from "./StepCommonInfo.vue?vue&type=template&id=1493a086&scoped=true&"
import script from "./StepCommonInfo.vue?vue&type=script&lang=js&"
export * from "./StepCommonInfo.vue?vue&type=script&lang=js&"
import style0 from "./StepCommonInfo.vue?vue&type=style&index=0&id=1493a086&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493a086",
  null
  
)

export default component.exports